import DarkButton from "components/actions/DarkButton";
import GrayButton from "components/actions/GrayButton";
import CheckIcon from "components/icons/Check";
import { useState } from "react";
import { DrawerHeader, DrawerBody } from "@chakra-ui/modal";
import TransparentButton from "components/actions/TransparentButton";
import { useNavigate } from "react-router-dom";
import Dialog from "components/dialog";
import InputField from "components/fields/InputField";
import AtriumApi from "api";
import Avatar from "components/avatar";
import CloseIcon from "components/icons/CloseIcon";
import toast from "react-hot-toast";
import Loader from "components/loader/Loader";

const ServiceDetails = ({ service, onDelete, getServices, type }) => {
  const [tempName, setTempName] = useState(service?.tempName || "");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const editService = (tab) => {
    navigate(
      "/admin/service-scheduling/services/" + service?.id + "/edit?tab=" + tab
    );
  };
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);

  // const deleteService = (e) => {
  //   e.preventDefault();
  //   e.target.setAttribute("disabled", "");
  //   setShowDeleteAlert(false);
  //   AtriumApi.delete(`/v1/services/${service.id}`).then(() => {
  //     e.target.removeAttribute("disabled");
  //     onDelete && onDelete(service.id);
  //   });
  // };

  const deleteService = async (e) => {
    e.preventDefault();
    try {
      const response = await AtriumApi.delete(`/v1/services/${service?.id}`);
      onDelete?.(service?.id);
      if (response) {
        toast.success(
          response?.data?.message || "Service deleted successfully"
        );
        getServices();
      }
    } catch (error) {
      console.error("Failed to delete service:", error);
      toast.error(error?.response?.data?.message || "Failed to delete service");
    } finally {
      setShowDeleteAlert(false);
    }
  };

  // save as template

  const saveAsTemplate = async () => {
    if (!type) return;
    try {
      setLoading(true);
      const payload = {
        isTemplate: true,
        tempName,
      };
      const response = await AtriumApi.put(
        `/v1/services/${service?.id}`,
        payload
      );
      if (response) {
        setLoading(false);
        toast.success(response?.data?.message || "Service saved as template");
        getServices();
        setShowTemplateForm(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Failed to save service as template:", error);
      toast.error(
        error?.response?.data?.message || "Failed to save service as template"
      );
    }
  };

  return (
    <>
      <DrawerHeader className="px-[32px] pt-6">
        <div className="font-bold text-xl text-gray-800 dark:text-white">
          {service?.name}
        </div>
      </DrawerHeader>
      <DrawerBody className="flex-1 px-[32px] my-6 overflow-auto">
        <div className="flex gap-4 py-6">
          <TransparentButton onClick={() => editService("details")}>
            <svg
              className="inline mr-2"
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99998 15.6667H16.5M1.5 15.6667H2.89545C3.3031 15.6667 3.50693 15.6667 3.69874 15.6206C3.8688 15.5798 4.03138 15.5125 4.1805 15.4211C4.34869 15.318 4.49282 15.1739 4.78107 14.8856L15.25 4.41669C15.9404 3.72634 15.9404 2.60705 15.25 1.91669C14.5597 1.22634 13.4404 1.22634 12.75 1.91669L2.28105 12.3856C1.9928 12.6739 1.84867 12.818 1.7456 12.9862C1.65422 13.1353 1.58688 13.2979 1.54605 13.468C1.5 13.6598 1.5 13.8636 1.5 14.2713V15.6667Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </TransparentButton>

          <TransparentButton onClick={() => editService("assign")}>
            <svg
              className="inline mr-2"
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99984 11.9167H6.24984C5.08687 11.9167 4.50538 11.9167 4.03222 12.0602C2.96688 12.3834 2.1332 13.217 1.81004 14.2824C1.6665 14.7555 1.6665 15.337 1.6665 16.5M15.8332 16.5V11.5M13.3332 14H18.3332M12.0832 5.25C12.0832 7.32107 10.4042 9 8.33317 9C6.2621 9 4.58317 7.32107 4.58317 5.25C4.58317 3.17893 6.2621 1.5 8.33317 1.5C10.4042 1.5 12.0832 3.17893 12.0832 5.25Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Assign people
          </TransparentButton>
        </div>

        <div className="flex flex-col gap-4">
          <div className="flex flex-row gap-2 border-b border-gray-300 pb-4">
            <div className="text-gray-700">Service type</div>
            <div className="flex-1 text-right dark:text-white">
              {service?.type}
            </div>
          </div>

          <div className="flex flex-row gap-2 border-b border-gray-300 pb-4">
            <div className="text-gray-700">Address</div>
            <div className="flex-1 text-right dark:text-white">
              {service?.address}
            </div>
          </div>

          <div className="flex flex-row gap-2 border-b border-gray-300 pb-4">
            <div className="text-gray-700">Service date</div>
            <div className="flex-1 text-right dark:text-white">
              {service?.date &&
                new Date(service?.date).toLocaleDateString(["en-US"], {
                  day: "numeric",
                  month: "numeric",
                  year: "numeric",
                })}
            </div>
          </div>

          <div className="flex flex-row gap-2 border-b border-gray-300 pb-4">
            <div className="text-gray-700">Service time</div>
            <div className="flex-1 text-right dark:text-white">
              {service?.startAt &&
                new Date("2000 Oct 4 " + service.startAt).toLocaleTimeString(
                  // ["en-US"],
                  undefined,
                  { hour: "2-digit", minute: "2-digit" }
                )}
              {" - "}
              {service?.endAt &&
                new Date("2000 Oct 4 " + service?.endAt).toLocaleTimeString(
                  // ["en-US"],
                  undefined,
                  { hour: "2-digit", minute: "2-digit" }
                )}
            </div>
          </div>
        </div>

        <h2 className="mt-6 font-bold dark:text-white mb-4">Assigned people</h2>
        {service?.users?.map((user) => (
          <div
            key={`user${user?.id}`}
            className="select-none flex flex-col gap-1 pt-2"
          >
            <div
              className={`transition-all duration-300 flex content-center items-center hover:cursor-pointer gap-2 p-2 rounded-2xl hover:bg-gray-100 dark:hover:bg-navy-700 bg-gray-100 dark:bg-navy-700`}
            >
              <Avatar user={user} size="sm" />
              <div className="flex-1">
                <div className="text-navy-700 font-bold text-sm dark:text-white">
                  {user?.firstName} {user?.lastName}
                </div>
                <div className="text-gray-600 text-xs capitalize">
                  {user?.role}
                </div>
              </div>
              {user?.state === "confirmed" && (
                <span className="text-white bg-brand-500 rounded-full">
                  <CheckIcon />
                </span>
              )}
              {user?.state === "declined" && (
                <span className="text-white bg-red-500 rounded-full p-1">
                  <CloseIcon />
                </span>
              )}
            </div>
          </div>
        ))}

        <Dialog
          isOpen={showDeleteAlert}
          onClose={() => setShowDeleteAlert(false)}
        >
          <div className="text-lg font-bold dark:text-white">
            Delete service
          </div>
          <p className="pt-4 text-gray-700 font-base">
            Service will be permanently deleted
          </p>

          <div className="flex gap-2 mt-6">
            <DarkButton kind="danger" onClick={deleteService}>
              Delete
            </DarkButton>
            <GrayButton onClick={() => setShowDeleteAlert(false)}>
              Cancel
            </GrayButton>
          </div>
        </Dialog>

        <Dialog
          isOpen={showTemplateForm}
          onClose={() => setShowTemplateForm(false)}
        >
          <div className="text-lg font-bold dark:text-white">
            Save as template
          </div>
          <InputField
            variant="service_form"
            label="Template name"
            placeholder="Add template name"
            id="name"
            type="text"
            value={tempName}
            onChange={(e) => setTempName(e.target.value)}
            extra="flex flex-col pt-4"
          />

          {loading ? (
            <div className="flex justify-center items-center h-full w-full py-4">
              <Loader />
            </div>
          ) : (
            <>
              <div className="flex gap-2 mt-6">
                <DarkButton disabled={!tempName} onClick={saveAsTemplate}>
                  Save as template
                </DarkButton>
                <GrayButton onClick={() => setShowTemplateForm(false)}>
                  Cancel
                </GrayButton>
              </div>
            </>
          )}
        </Dialog>

        <div className="flex gap-4 py-6">
          <TransparentButton onClick={() => setShowTemplateForm(true)}>
            <svg
              className="inline mr-2"
              width="14"
              height="18"
              viewBox="0 0 14 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.00008 9.83333V4.83333M4.50008 7.33333H9.50008M12.8334 16.5V5.5C12.8334 4.09987 12.8334 3.3998 12.5609 2.86502C12.3212 2.39462 11.9388 2.01217 11.4684 1.77248C10.9336 1.5 10.2335 1.5 8.83341 1.5H5.16675C3.76662 1.5 3.06655 1.5 2.53177 1.77248C2.06137 2.01217 1.67892 2.39462 1.43923 2.86502C1.16675 3.3998 1.16675 4.09987 1.16675 5.5V16.5L7.00008 13.1667L12.8334 16.5Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Save as template
          </TransparentButton>

          <TransparentButton
            kind="danger"
            onClick={() => setShowDeleteAlert(true)}
          >
            <svg
              className="inline mr-2"
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3333 4.99984V4.33317C12.3333 3.39975 12.3333 2.93304 12.1517 2.57652C11.9919 2.26292 11.7369 2.00795 11.4233 1.84816C11.0668 1.6665 10.6001 1.6665 9.66667 1.6665H8.33333C7.39991 1.6665 6.9332 1.6665 6.57668 1.84816C6.26308 2.00795 6.00811 2.26292 5.84832 2.57652C5.66667 2.93304 5.66667 3.39975 5.66667 4.33317V4.99984M7.33333 9.58317V13.7498M10.6667 9.58317V13.7498M1.5 4.99984H16.5M14.8333 4.99984V14.3332C14.8333 15.7333 14.8333 16.4334 14.5608 16.9681C14.3212 17.4386 13.9387 17.821 13.4683 18.0607C12.9335 18.3332 12.2335 18.3332 10.8333 18.3332H7.16667C5.76654 18.3332 5.06647 18.3332 4.53169 18.0607C4.06129 17.821 3.67883 17.4386 3.43915 16.9681C3.16667 16.4334 3.16667 15.7333 3.16667 14.3332V4.99984"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Delete service
          </TransparentButton>
        </div>
      </DrawerBody>
    </>
  );
};

export default ServiceDetails;
